import React from "react";
import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";
import CustomLine from "./customLine";

const LoadingHistoryRecord = ({
  commonLoading,
  children,
  className,
  mapIndex = 5,
}) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return commonLoading || loadingStatus
    ? Array.from({ length: mapIndex }, (_, i) => i).map((item) => {
        return (
          <Placeholder
            inverted={isDarkMode}
            className={`${className} min-h-[137px] rounded-xl !mt-0 mb-[10px] p-[12px] flex items-center justify-between`}
          >
            <div className="flex flex-col justify-between items-start  h-full w-full">
              <CustomLine className={`w-[45px] h-[15px]`} circle />
              <div className="flex items-start gap-[5px]">
                <CustomLine className={`h-[10px] w-[30px]`} />
                <CustomLine className={`h-[10px] w-[200px]`} />
              </div>
              <div className="flex items-start gap-[5px]">
                <CustomLine className={`h-[10px] w-[30px]`} />
                <CustomLine className={`h-[10px] w-[200px]`} />
              </div>
              <div className="flex items-center justify-between w-full">
                <div className="flex flex-col gap-[5px]">
                  <CustomLine className={`h-[10px] w-[30px]`} />
                  <CustomLine className={`h-[10px] w-[70px]`} />
                </div>
                <div className="flex flex-col items-start gap-[5px]">
                  <CustomLine className={`h-[10px] w-[30px]`} />
                  <CustomLine className={`h-[10px] w-[70px]`} />
                </div>
              </div>
            </div>
          </Placeholder>
        );
      })
    : children;
};

export default LoadingHistoryRecord;
